import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { SectionEyebrow } from './SectionEyebrow';
const faqs = [{
  question: '¿Cómo recibiré mi compra?',
  answer: 'Recibirás acceso digital a tu correo electrónico inmediatamente después de completar tu compra, para que puedas empezar tu transformación al instante.'
}, {
  question: '¿El acceso es inmediato?',
  answer: 'Sí, el acceso es completamente inmediato. No tienes que esperar para comenzar tu proceso.'
}, {
  question: '¿Es un producto físico o digital?',
  answer: 'Es un producto 100% digital. Esto te permite llevarlo contigo a todas partes y abrirlo en el momento que más lo necesites.'
}, {
  question: '¿Puedo verlo desde mi celular?',
  answer: 'Sí, puedes verlo cómodamente desde tu celular, tablet o computadora. El formato está pensado para acompañarte donde estés.'
}, {
  question: '¿Qué incluye exactamente mi compra?',
  answer: 'Incluye el ebook principal “Glow Up Femenino en 30 Días” y los 3 bonos digitales: Eleva tus estándares, Diario de sanación y claridad, y Declaraciones para volver a ti.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="py-20 md:py-32 px-6 bg-background" data-id="element-57">
      <div className="container max-w-[800px] mx-auto" data-id="element-58">
        <div className="text-center mb-12 md:mb-16" data-id="element-59">
          <SectionEyebrow text="Preguntas Frecuentes" className="mb-6" data-id="element-60" />
          <h2 className="text-4xl text-foreground" data-id="element-61">
            Resolvemos tus{' '}
            <span className="italic text-muted-foreground" data-id="element-62">dudas</span>
          </h2>
        </div>

        <div className="space-y-2" data-id="element-63">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.08
        }} className="border-b border-border/60" data-id="element-64">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between py-5 md:py-6 text-left focus:outline-none group gap-4" data-id="element-65">
                <span className="font-serif text-lg md:text-2xl text-foreground group-hover:text-accent transition-colors" data-id="element-66">
                  {faq.question}
                </span>
                <motion.div animate={{
              rotate: openIndex === index ? 180 : 0
            }} transition={{
              duration: 0.3
            }} className="shrink-0" data-id="element-67">
                  <ChevronDown className="w-5 h-5 text-muted-foreground" data-id="element-68" />
                </motion.div>
              </button>

              <AnimatePresence data-id="element-69">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} className="overflow-hidden" data-id="element-70">
                    <p className="pb-6 text-muted-foreground font-light text-base md:text-lg leading-relaxed pr-8" data-id="element-71">
                      {faq.answer}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}